import * as Dialog from '@radix-ui/react-dialog';
import { Loader2 } from 'lucide-react';
import { SegmentPreviewResult } from '../../queries/marketingSegments';

interface SegmentPreviewDialogProps {
  segmentName: string;
  isLoading: boolean;
  result: SegmentPreviewResult | null;
  onClose: () => void;
}

export function SegmentPreviewDialog({ segmentName, isLoading, result, onClose }: SegmentPreviewDialogProps) {
  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-2xl -translate-x-1/2 -translate-y-1/2 rounded-lg border border-border bg-background p-6 shadow-lg">
          <Dialog.Title className="text-lg font-semibold">
            Preview — {segmentName}
            {result && ` (${result.count} matching users)`}
          </Dialog.Title>

          {isLoading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
          ) : (
            <div className="mt-4 max-h-96 overflow-y-auto rounded-md border border-border">
              <table className="w-full text-sm">
                <thead className="bg-muted text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
                  <tr>
                    <th className="px-3 py-2">Email</th>
                    <th className="px-3 py-2">Name</th>
                    <th className="px-3 py-2">Status</th>
                    <th className="px-3 py-2">Registered</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {(result?.sample ?? []).map((user) => (
                    <tr key={user.cognito_id}>
                      <td className="px-3 py-2">{user.email ?? '—'}</td>
                      <td className="px-3 py-2 text-muted-foreground">{user.display_name ?? '—'}</td>
                      <td className="px-3 py-2 text-muted-foreground">{user.subscription_status ?? '—'}</td>
                      <td className="px-3 py-2 text-muted-foreground">{new Date(user.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                  {(result?.sample.length ?? 0) === 0 && (
                    <tr>
                      <td colSpan={4} className="px-3 py-6 text-center text-muted-foreground">
                        No matching users.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="mt-4 flex justify-end">
            <button type="button" onClick={onClose} className="rounded-md border border-input px-3 py-1.5 text-sm font-medium hover:bg-accent">
              Close
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
